// This is a magic string replaced by rollup

const SDK_VERSION = "9.46.0" ;

export { SDK_VERSION };
